"use strict";

angular.module("core")
.service("CoreOrderService", function($q, $resource, $http, appConfig, FlashBag, ModalService, gettextCatalog) {
    this.get = function(orderId) {
        return $http({
            method: "get",
            url: appConfig.API_SERVER + "/catalog/" + appConfig.APP + "/orders/" + orderId + "/"
        });
    };

    this.showOrderModificationConfirmationModal = function(message) {
        var deferred = $q.defer();
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Order Modification Confirmation"),
                    context: message,
                    message: gettextCatalog.getString("Do you want to modify this order?")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    deferred.reject();
                    return;
                }
                deferred.resolve(true);
            });
        });
        return deferred.promise;
    };

    this.getStatusHtmlContent = function() {
        return gettextCatalog.getString("Order status help tip html");
    };

    this.getOtherChargesLocalized = function() {
        var resource = $resource(appConfig.API_SERVER + "/charges/other-charge-translations/", {}, {
            get: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return resource.get();
    };

    this.getTaxesLocalized = function() {
        var resource = $resource(appConfig.API_SERVER + "/charges/tax-translations/", {}, {
            get: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return resource.get();
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/order/core-order.service.js
// module id = 432
// module chunks = 0